import { v4 as uuidv4 } from "uuid";

export const getDeviceId = () => {
  const DeviceId = localStorage.getItem("deviceId");
  let newDeviceId;
  if (!DeviceId) {
    newDeviceId = uuidv4();
    localStorage.setItem("deviceId", newDeviceId);
  }
  return newDeviceId;
};
